<template lang="pug">
.header-user.me-3
  .header-user__signup(v-if='registrationText')
    SignLink.header-user__link(:to="registrationLink") {{ registrationText}}
  .header-user__signin
    SignLink(:to="entranceLink") {{ entranceText}}
</template>

<script>
import SignLink from './SignLink.vue';

export default {
  components: {
    SignLink,
  },

  props: {
    registrationLink: {
      type: [String, Object],
    },

    registrationText: {
      type: String,
      default: '',
    },

    entranceLink: {
      type: [String, Object],
    },

    entranceText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.header-user {
  &__signup,
  &__signin {
    display: inline-block;
    font-weight: normal;
  }

  &__signup {
    font-weight: bold;

    &::after {
      content: '|';
      font-size: 1.33333em;
      color: #8b9299;
      display: inline-block;
      padding-left: 15px;
      padding-right: 15px;

      @media only screen and (max-width: 20em) {
        padding-left: 3px;
        padding-right: 3px;
      }
    }
  }

  &__link,
  &__link:hover {
    font-weight: 700;
    color: #69be63 !important;
  }
}
</style>



// WEBPACK FOOTER //
// User.vue?acde611c